import { render, staticRenderFns } from "./comp_CheckoutStep-delivery.vue?vue&type=template&id=fa19d7a0&scoped=true&"
import script from "./comp_CheckoutStep-delivery.vue?vue&type=script&lang=js&"
export * from "./comp_CheckoutStep-delivery.vue?vue&type=script&lang=js&"
import style0 from "./comp_CheckoutStep-delivery.vue?vue&type=style&index=0&id=fa19d7a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa19d7a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCard,VIcon,VProgressLinear,VRadioGroup})
